// extracted by css-extract-rspack-plugin
export default {"popoverContent":"xONZnW","enter":"Us98Fa","exit":"NxatYk"};